import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class ProgressRing extends Vue {
	@Prop() public progress!: number; // 0 ~ 100
	@Prop() public ringWidth!: number;
	@Prop() public ringR!: number;
	private circumference: number = 0;
	private d: string = '';
	private strokeDashoffset: string = '';
	private strokeDasharray: string = '';
	// private viewBox!: string;
	// lifecycle event
	public created(): void {
		if (this.ringR === undefined) {
			return;
		}
		const x0: number = this.ringR;
		const y0: number = this.ringR;
		const rw: number = (this.ringWidth === undefined) ? 1 : this.ringWidth;
		const r: number = this.ringR - Math.round(rw * 0.5);
		const diameter: number = r * 2.0;
		// 円弧のパスを設定
		this.d = `M ${x0},${y0} m 0,-${r} a ${r},${r} 0 1 1 0,${diameter} a ${r},${r} 0 1 1 0,-${diameter}`;
		// 円弧の塗りつぶしを設定
		this.circumference = Math.round(2.0 * Math.PI * r);
		this.strokeDasharray = `${this.circumference} ${this.circumference}`;
		const progress: number = (this.progress === undefined) ? this.circumference :
			(this.circumference - this.circumference * this.progress * 0.01);
		this.strokeDashoffset = `${progress}`;
	}

	@Watch('progress')
	private onProgressChange(newProgress: number, oldProgress: number): void {
		if ((newProgress < 0) || (newProgress > 100)) {
			return;
		}
		const dashoffset: number = (this.circumference - this.circumference * this.progress * 0.01);
		this.strokeDashoffset = `${dashoffset}`;
	}
}
